import kebabCase    from '../../../../../Lib/helpers/kebabCase';
import LineOutput   from './LineOutput';

export default class ScssLine extends LineOutput {

    output() {
        return `$${kebabCase(this.subject.name)}: ${this.decorator.output()};`;
    }

}